import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { getAccessToken, removeSession } from '../../modules/common/session'
import { LOGIN, UNAUTHORIZED } from '../../constants/Paths'
import { useAppDispatch } from '../../hooks'
import { getUser } from '../../modules/User'
import { getTeam, getTeamGroups } from '../../modules/Team'
import CommonLoadingView from '../common/CommonLoadingView'
import { getNews } from '../../modules/News'

type Props = {
  children: JSX.Element
}

const RequireAuth = ({ children }: Props) => {
  const dispatch = useAppDispatch()

  const [isLoading, setIsLoading] = useState(true)
  const [hasAccessError, setHasAccessError] = useState(false)

  useEffect(() => {
    Promise.all(
      [
        dispatch(getUser()).unwrap(),
        dispatch(getTeam()).unwrap(),
        dispatch(getTeamGroups(true)).unwrap(),
        dispatch(getNews()).unwrap(),
      ],
    )
      .catch((error: any) => {
        console.error('RequireAuth error:', error)
        // 403エラー（IPブロック等）の場合はUnauthorizedページへリダイレクト
        const errorStr = typeof error === 'string' ? error : error?.toString() || ''
        if (errorStr.includes('403') || errorStr.toLowerCase().includes('forbidden')) {
          setHasAccessError(true)
        }
      })
      .finally(() => setIsLoading(false))
  }, [dispatch])

  if (!getAccessToken()) {
    removeSession()
    return <Redirect to={LOGIN} />
  }

  if (hasAccessError) {
    return <Redirect to={UNAUTHORIZED} />
  }

  if (isLoading) {
    return (<CommonLoadingView />)
  }

  return children
}

export default RequireAuth
